import React from "react";

/**
 * GeckoTerminal chart embed. Pool address = the DAMM v2 pool PDA we
 * stored in `tokens.pool` at launch. GeckoTerminal indexes every Solana
 * DEX pool automatically, so any token launched through Slurp is
 * already there with full OHLC, volume, swaps, indicators — for free.
 *
 * Why iframe instead of our own Lightweight Charts impl: doing OHLC
 * candles correctly (auto-bucket on density, gap fills, log mode,
 * outlier hygiene, indicator panel, drawing tools) is multi-week work.
 * GeckoTerminal nailed it. We embed until TradingView Advanced is
 * approved, then swap to that with our own indexer-fed datafeed.
 */
export default function TVChart({ pool, height = 500 }) {
  if (!pool) {
    return (
      <div className="pm-chart-empty" style={{ height }}>
        Chart unavailable
      </div>
    );
  }

  // GeckoTerminal embed params:
  //   embed=1            chart-only mode (no GT site chrome)
  //   info=0             hide token info sidebar
  //   swaps=0            hide swaps sidebar
  //   grayscale=0        keep brand colour candles
  //   light_chart=0      force dark mode
  //   chart_type=price   default to price (we can flip to mcap)
  //   resolution=1m      default resolution
  const src =
    `https://www.geckoterminal.com/solana/pools/${pool}` +
    `?embed=1&info=0&swaps=0&grayscale=0&light_chart=0`;

  // Cover strip at the bottom — GeckoTerminal renders a "Powered by
  // GeckoTerminal" attribution at the foot of the embed. We hide it
  // with a same-color strip so the chart blends into the page. Tall
  // enough to clear the attribution row, narrow enough to not eat into
  // the time axis labels.
  return (
    <div className="pm-tvchart" style={{ height, position: "relative" }}>
      <iframe
        title="Price chart"
        src={src}
        width="100%"
        height="100%"
        frameBorder="0"
        loading="lazy"
        allow="clipboard-read; clipboard-write; fullscreen"
        allowFullScreen
      />
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          height: 28,
          background: "#0d0b09",
          pointerEvents: "none",
        }}
      />
    </div>
  );
}
